import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { isEnabledForFrontierCopilotAudience, type FrontierFlightConfig, } from "./isEnabledForFrontierCopilotAudience";

const copilotSearchAnswerFrontierFlights: FrontierFlightConfig = {
    publicFlight: "sea-copilotSearchAnswer-frontier-public",
    privateTapFlight: "sea-copilotSearchAnswer-frontier-private-tap",
    privateStagingFlight: "sea-copilotSearchAnswer-frontier-private-staging",
    privateInfluencerFlight: "sea-copilotSearchAnswer-frontier-private-influencer",
};

export function isCopilotSearchAnswerEnabled(mailboxInfo: MailboxInfo): boolean {
    return (isAccountFeatureEnabled("sea-copilotSearchAnswer", mailboxInfo) ||
        isEnabledForFrontierCopilotAudience(mailboxInfo, copilotSearchAnswerFrontierFlights));
}
